module.exports = __webpack_public_path__ + "img/1-3.7f36cfe6.png";